(function () {
  'use strict';

  angular
    .module('app.page-project-attributes', []);
})();
